var _g, _path, _path2, _path3, _g2, _path4, _path5, _path6, _path7, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 228,
    viewBox: "0 0 236 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1598_366)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1598_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.688 20H52.25C42.585 20 34.75 27.8421 34.75 37.5158V192.968C34.75 202.642 42.585 210.484 52.25 210.484H185.688C195.352 210.484 203.188 202.642 203.188 192.968V37.5158C203.188 27.8421 195.352 20 185.688 20Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.398 138.544L152.146 139.715L142.693 151.879V158.637L149.895 166.566L158.177 164.854L164.478 166.115L163.128 170.98L167.449 178.819L165.289 184.316L170.389 199.226L177.261 198.101L183.563 190.983L184.103 186.027L188.154 182.964L187.344 174.044L198.058 160.318L191.395 161.25L181.222 143.499L165.198 142.418L163.398 138.544ZM195.742 179.571L193.896 182.247L192.178 182.31C190.659 185.43 190.563 187.188 190.395 190.848L192.623 191.421L195.424 184.731L195.742 179.571Z",
    fill: "#A2CF6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.562 171.074H128.812V179.832H137.562V171.074Z",
    fill: "#55A630"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.562 186.4H128.812V195.158H137.562V186.4Z",
    fill: "#55A630"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1598_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.562 35.3263H71.9375C67.105 35.3263 63.1875 39.2474 63.1875 44.0842V109.768C63.1875 114.605 67.105 118.526 71.9375 118.526H207.562C212.395 118.526 216.312 114.605 216.312 109.768V44.0842C216.312 39.2474 212.395 35.3263 207.562 35.3263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.562 36.4211H71.9376C67.7092 36.4211 64.2812 39.852 64.2812 44.0842V109.768C64.2812 114.001 67.7092 117.432 71.9376 117.432H207.562C211.791 117.432 215.219 114.001 215.219 109.768V44.0842C215.219 39.852 211.791 36.4211 207.562 36.4211Z",
    stroke: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.571 95.1771C128.425 96.7277 131.213 96.493 132.502 94.4476C134.627 91.0753 136.128 87.3331 136.918 83.4006C137.996 78.0318 137.717 72.4784 136.104 67.2456C134.491 62.0129 131.597 57.2668 127.684 53.4392C124.818 50.6353 121.472 48.3896 117.818 46.8016C115.602 45.8382 113.166 47.216 112.507 49.5428L110.419 56.9154C109.759 59.2419 111.157 61.6175 113.226 62.867C114.305 63.5186 115.309 64.2946 116.216 65.1826C118.173 67.0965 119.62 69.4696 120.427 72.086C121.233 74.7025 121.373 77.4792 120.833 80.1635C120.583 81.409 120.19 82.6163 119.666 83.7627C118.66 85.9616 118.842 88.7127 120.696 90.2633L126.571 95.1771Z",
    fill: "#55A630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.534 48.8685C109.94 46.4846 108.336 44.1912 105.921 44.1049C102.102 43.9687 98.2779 44.5005 94.6221 45.6879C90.9666 46.8752 87.5589 48.6925 84.548 51.0473C82.644 52.5363 82.6906 55.3358 84.4183 57.0265L89.8923 62.3842C91.62 64.0749 94.3727 63.9801 96.4576 62.7575C97.4748 62.1611 98.557 61.6739 99.6864 61.3069C100.816 60.9402 101.978 60.6985 103.151 60.5833C105.556 60.3475 107.84 58.8066 108.246 56.4224L109.534 48.8685Z",
    fill: "#D4D700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0201 59.8215C80.0888 58.3681 77.317 58.7458 76.1346 60.8549C74.0495 64.5744 72.7011 68.6772 72.1803 72.9382C71.4818 78.6534 72.2967 84.452 74.5432 89.7525C76.7898 95.053 80.3893 99.6692 84.9805 103.138C88.4037 105.725 92.2882 107.606 96.4093 108.69C98.7462 109.304 100.944 107.572 101.242 105.172L102.186 97.5673C102.484 95.1675 100.742 93.0323 98.5073 92.112C97.2149 91.5798 95.9901 90.8822 94.8653 90.0323C92.5695 88.2978 90.7699 85.9896 89.6466 83.3395C88.5233 80.6891 88.1158 77.7898 88.4651 74.9323C88.6362 73.532 88.9862 72.1657 89.502 70.8658C90.3939 68.6181 90.071 65.88 88.1396 64.4266L82.0201 59.8215Z",
    fill: "#AACC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.75 105.389C104.75 107.808 106.717 109.798 109.112 109.477C111.921 109.1 114.677 108.359 117.307 107.268C119.937 106.178 122.408 104.752 124.662 103.03C126.582 101.563 126.567 98.7628 124.858 97.0528L119.445 91.6341C117.736 89.9241 114.982 89.988 112.884 91.1872C112.286 91.5286 111.667 91.8327 111.028 92.0974C110.39 92.3621 109.737 92.5854 109.073 92.7669C106.743 93.4043 104.75 95.3078 104.75 97.7263V105.389Z",
    fill: "#55A630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.562 58.3158H152.875V62.6947H207.562V58.3158Z",
    fill: "#55A630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.562 69.2632H152.875V73.6421H207.562V69.2632Z",
    fill: "#55A630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.562 80.2104H152.875V84.5894H207.562V80.2104Z",
    fill: "#55A630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.875 91.1578H152.875V95.5367H187.875V91.1578Z",
    fill: "#55A630"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.312 149.179H56.625V153.558H111.312V149.179Z",
    fill: "#55A630"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.312 160.126H56.625V164.505H111.312V160.126Z",
    fill: "#55A630"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1875 171.074H56.625V175.453H98.1875V171.074Z",
    fill: "#55A630"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.625 182.021H56.625V186.4H91.625V182.021Z",
    fill: "#55A630"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1598_366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H8C3.58172 0 0 3.58172 0 8V48C0 52.4183 3.58172 56 8 56H48C52.4183 56 56 52.4183 56 48V8C56 3.58172 52.4183 0 48 0Z",
    fill: "#FFFDB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8571 36.5714H17.7143C16.768 36.5714 16 35.8017 16 34.8571V29.7143C16 28.7697 16.768 28 17.7143 28H22.8571V24.5714C22.8571 23.6269 23.6251 22.8571 24.5714 22.8571H29.7143V17.7143C29.7143 16.7697 30.4823 16 31.4286 16H36.5714C37.5177 16 38.2857 16.7697 38.2857 17.7143V24.5714H36.5714V17.7143H31.4286V22.8571C31.4286 23.8017 30.6606 24.5714 29.7143 24.5714H24.5714V28C24.5714 28.9446 23.8034 29.7143 22.8571 29.7143H17.7143V34.8571H22.8571V36.5714ZM40 35.7143V28C40 27.0554 39.232 26.2857 38.2857 26.2857H33.1429C32.1966 26.2857 31.4286 27.0554 31.4286 28V31.4286H26.2857C25.3394 31.4286 24.5714 32.1983 24.5714 33.1429V38.2857C24.5714 39.2303 25.3394 40 26.2857 40H35.7143C38.0783 40 40 38.0766 40 35.7143Z",
    fill: "#05C25E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1598_366",
    x: 30.75,
    y: 20,
    width: 176.438,
    height: 198.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1598_366",
    x: 30.75,
    y: 20,
    width: 176.438,
    height: 198.484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1598_366",
    x: 63.1875,
    y: 35.3263,
    width: 162.124,
    height: 92.1997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_366",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1598_366",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.592 0 0 0 0 0.988 0 0 0 0 0.78 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1598_366"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1598_366",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome4);
export default __webpack_public_path__ + "static/media/home_4.457f1fa5d380682a85b79ac14186da72.svg";
export { ForwardRef as ReactComponent };